import UplatformLogo from '@/assets/headerLogos/uplatform.svg'
import SignInLogo from '@/assets/tenants/uplatform/signInLogo.svg'

import type { TenantConfig } from '../types'

import { uplatformTheme } from './uplatform.theme'
export const uplatformConfig: TenantConfig = {
  tenantId: 'uplatform',
  companyName: 'Uplatform',
  logoUrl: UplatformLogo,
  signInPageLogoUrl: SignInLogo,
  favicon: {
    path: '/tenants/uplatform/favicon.ico',
    type: 'image/x-icon',
  },
  title: {
    default: 'Uplatform',
    suffix: ' - Uplatform',
  },
  enabledSystemModules: [
    'admin',
    'auth',
    'events',
    'faq',
    'my-orders',
    'news',
    'profile',
    'profiles',
    'shop',
    'allocate-coins',
    'control-feedback',
    'feedback',
    'metrics',
    'privacy-policy',
    'roles-control',
    'tags-control',
    'test',
    'transactions',
    'shop-management',
    'orders-management',
  ],
  locales: [
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'ru',
      name: 'Russian',
    },
  ],
  defaultLocale: 'en',
  theme: uplatformTheme,
  meta: {
    shippingLimit: 'months',
  },
}
